export default function svgIconUrl(iconName: string): string {
  const images = require.context('@/assets/images/common/', false, /\.svg$/);
  return images(`./${iconName}.svg`);
}
